// extracted by mini-css-extract-plugin
export default {"customButton":"Button_customButton__WZUMq","hasIcon":"Button_hasIcon__nB0Nn"};